__turbopack_context__.v({
  "container": "WinnerSection-module__VtNprq__container",
  "textMaxWidth": "WinnerSection-module__VtNprq__textMaxWidth",
});
